module.exports = __webpack_public_path__ + "img/space-station-moon-construction.0ff861df.svg";